import React from "react";

import { GoogleBrandMark } from "./GoogleBrandMark";

/**
 * Branded Google button (logo + label). Styling follows Sign in with Google neutral/light spec
 * (white surface, #747775 border, dark label) so it reads clearly on dark app themes.
 */
export function GoogleSignInButton({
  type = "button",
  onClick,
  disabled = false,
  loading = false,
  label = "Sign in with Google",
  size = "default",
  className = "",
  ...rest
}) {
  const compact = size === "compact";
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled || loading}
      className={[
        "inline-flex items-center justify-center rounded border border-[#747775] bg-white shadow-sm transition hover:bg-[#f8f9fa] disabled:cursor-not-allowed disabled:opacity-60",
        compact
          ? "w-auto gap-2 px-3 py-2 font-sans text-xs font-medium text-[#1f1f1f]"
          : "w-full gap-3 px-4 py-2.5 font-sans text-sm font-medium text-[#1f1f1f]",
        className,
      ].join(" ")}
      {...rest}
    >
      {loading ? (
        <span className="font-mono text-xs text-[#1f1f1f]">Please wait...</span>
      ) : (
        <>
          <GoogleBrandMark className={compact ? "h-4 w-4 shrink-0" : "h-5 w-5 shrink-0"} decorative />
          <span>{label}</span>
        </>
      )}
    </button>
  );
}
